import ArticleWidget from "./ArticleWidget";

const { register } = require("@lpm/pug-components/dist/register");

register("ArticleWidget/ArticleWidget", ArticleWidget);